import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FooterStyled } from '@components/organisms/footer/styled-components';

interface IFooterProps { }

export const Footer: React.FC<IFooterProps> = () => {
    // const location = useLocation();
    // const navigate = useNavigate();
    // const handlingOnBack = () => {
    //     navigate(-1);
    // };
    // if (location.state?.shouldHaveBackButton) {
    //     return <FooterStyled>

    //     </FooterStyled>;
    // }
    return null;
};
